module.exports = __webpack_public_path__ + "assets/689fe05f4a06543f654dce4882089b23.mp3";